// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tel-input .form-control {
  width: 100%;
}

.inputmaxlengthdiv {
  position: relative;
}

.inputmaxlength {
  position: absolute;
  right: 5px;
  bottom: 3px;
  z-index: 1000;
}

.has-error .inputmaxlength{
  color: red;
}

.inputsubtext {
  line-height: 1.5px;
}

.uploadwrapper {
  padding:5px;
  width: 100%;
  display:flex;
  border:1px solid #AAAAAA;
  height:42px;
  border-radius:5px;
  cursor:pointer;
}

.uploadwrapper .uploadfilename {
  width:252px;
  color:#AAAAAA;
  margin:5px;
  text-overflow: ellipsis;
  overflow: hidden;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0.15px;
}

.required {
  color: #F86567;
  font-weight: 500;
}

.fileuploadicon{
  margin:auto;
  color:#2E6EDF

}
.fileuploadtext {
  width:53px;
  color:#2E6EDF;
  margin:5px
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/input/Input.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,gBAAgB;;EAEhB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX;;AAEF;AACA;EACE,UAAU;EACV,aAAa;EACb;AACF","sourcesContent":[".react-tel-input .form-control {\n  width: 100%;\n}\n\n.inputmaxlengthdiv {\n  position: relative;\n}\n\n.inputmaxlength {\n  position: absolute;\n  right: 5px;\n  bottom: 3px;\n  z-index: 1000;\n}\n\n.has-error .inputmaxlength{\n  color: red;\n}\n\n.inputsubtext {\n  line-height: 1.5px;\n}\n\n.uploadwrapper {\n  padding:5px;\n  width: 100%;\n  display:flex;\n  border:1px solid #AAAAAA;\n  height:42px;\n  border-radius:5px;\n  cursor:pointer;\n}\n\n.uploadwrapper .uploadfilename {\n  width:252px;\n  color:#AAAAAA;\n  margin:5px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n}\n\n.required {\n  color: #F86567;\n  font-weight: 500;\n}\n\n.fileuploadicon{\n  margin:auto;\n  color:#2E6EDF\n\n}\n.fileuploadtext {\n  width:53px;\n  color:#2E6EDF;\n  margin:5px\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
